import React, {createContext, useContext, useState} from 'react'
import PropTypes from 'prop-types'

/**
 * Preview Context
 * Provides preview content from CMS to components that normally fetch via useOptimizelyPage
 * This allows ProductDetail/ProductList components to receive CMS content during on-page editing
 *
 * Usage:
 * 1. Wrap the preview page component with PreviewProvider
 * 2. Pass the CMS content and page identifier (e.g., 'pdp', 'plp', categoryId)
 * 3. useOptimizelyPage will check this context and return preview content if available
 */

const PreviewContext = createContext({
    previewContent: null,
    pageIdentifier: null,
    isPreviewMode: false
})

export const PreviewProvider = ({children, content, pageIdentifier}) => {
    const value = {
        previewContent: content,
        pageIdentifier,
        isPreviewMode: !!content
    }

    return <PreviewContext.Provider value={value}>{children}</PreviewContext.Provider>
}

PreviewProvider.propTypes = {
    children: PropTypes.node.isRequired,
    content: PropTypes.object,
    pageIdentifier: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ])
}

export const usePreviewContext = () => {
    return useContext(PreviewContext)
}

export default PreviewContext
